module.exports = __webpack_public_path__ + "static/img/systemli5.ea2f3a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/systemli5.png
// module id = Wm5C
// module chunks = 1